module.exports = __webpack_public_path__ + "img/logo-credencial.76d49e57.png";